/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SeatInfoResponse {
  seat_count: number;
  active_seats: number;
  pending_invitations: number;
  available_seats: number;
}
